import { Model } from "vue-mc";

export class CodigoIndustrial extends Model {
  defaults() {
    return {
      clave: null
      , codigo: null
      , descripcion: ""
      , status: true
    };
  }

  mutations() {
    return {
      clave: (clave) => clave
      , codigo: (codigo) => codigo
      , descripcion: (descripcion) => descripcion
      , status: (status) => status
    };
  }

  validation() {
    return {};
  }

  options() {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/models/operativos/codigoindustrial.js